module.exports = __webpack_public_path__ + "img/1486130652.ca94ee00.jpg";